export default "__VITE_ASSET__B7AJe6Bl__"